<template>
  <div>
    <div class="list-toolbar">
      <el-input
        v-model="filter"
        size="small"
        prefix-icon="el-icon-search"
        placeholder="filter by code or name"
        clearable
        class="list-filter"
      ></el-input>
      <el-button
        size="small"
        icon="el-icon-refresh"
        :loading="loading"
        @click="getData"
        >Refresh</el-button
      >
    </div>
    <div class="app-card">
      <el-table
        border
        ref="table"
        :data="tableData"
        size="small"
        v-loading="loading"
        class="app-table"
        :max-height="tableHeight"
      >
        <el-table-column
          :label="$t('text.name') | firstLetterCapitalize"
          prop="name"
        />
        <el-table-column
          :label="$t('text.address') | firstLetterCapitalize"
          prop="address"
        />
        <el-table-column
          :label="$t('text.contact') | firstLetterCapitalize"
          prop="contact"
        />
        <el-table-column label="Active" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.isEnabled ? 'success' : 'info'"
              size="small"
              class="status-tag"
              >{{ row.isEnabled ? 'Yes' : 'No' }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          v-if="p('Products.Manufacturers.Edit')"
          :label="$t('text.action') | firstLetterCapitalize"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              plain
              @click="edit(scope.row)"
            >
              {{ $t('text.view') | firstLetterCapitalize }}/{{
                $t('text.edit') | firstLetterCapitalize
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <EditManufacturers ref="editManufacturers" @saved="getData" />
  </div>
</template>

<script>
import EditManufacturers from '@/components/products/manufacturers/EditManufacturers'
import ApiService from '@/services/CommonApiService.js'
import loraTableHeight from '@/mixins/loraTableHeight'
import { subscriptionCodeStatus } from '../../../const'
export default {
  mixins: [loraTableHeight],
  data() {
    return {
      subscriptionCodeStatus,
      tableData: [],
      loading: false,
      filter: '',
      timer: ''
    }
  },
  components: {
    EditManufacturers
  },
  mounted() {
    this.getData()
    if (this.p('Products.Manufacturers.Add') && this.$parent.setPageAction) {
      this.$parent.setPageAction({
        label: 'Add Manufacturer',
        onClick: this.add
      })
    }
  },
  beforeDestroy() {
    if (this.$parent.clearPageAction) this.$parent.clearPageAction()
  },
  computed: {
    statusFontClass() {
      return status => {
        let className = ''
        switch (status) {
          case this.subscriptionCodeStatus.trial:
            className = 'red-font'
            break
          case this.subscriptionCodeStatus.approved:
            className = 'green-font'
            break
          default:
            className = 'dark-grey-font'
        }
        return className
      }
    }
  },
  watch: {
    filter() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetManufactures()
        .then(response => {
          this.loading = false
          this.tableData = response.data.data
          if (this.filter) {
            this.tableData = this.tableData.filter(item => {
              return (
                item.name.toLowerCase().indexOf(this.filter.toLowerCase()) >
                  -1 ||
                item.manufacturerCode
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1
              )
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editManufacturers.openDialog()
    },
    edit(row) {
      this.$refs.editManufacturers.openDialog()
      this.$refs.editManufacturers.form = JSON.parse(JSON.stringify(row))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.list-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.list-filter {
  width: 240px;
}
</style>
